import {Component, Input} from "@angular/core";
import {BreakpointsComponent} from "@shared/clases";
import {TipoPreguntaComponent} from "../tipo-pregunta/tipo-pregunta.component";

@Component({
    template: "app-tipo-pregunta-breakpoints"
})
export abstract class TipoPreguntaBreakpointComponent extends BreakpointsComponent implements TipoPreguntaComponent {
    @Input() public accesoPublico = false;
}
